import React from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  fullScreen?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = 'md', fullScreen = false }) => {
  const sizeClasses = {
    sm: 'loading-sm',
    md: 'loading-md', 
    lg: 'loading-lg'
  };

  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-base-200">
        <div className="text-center">
          <div className="relative">
            <span className={`loading loading-spinner ${sizeClasses[size]} text-primary`}></span>
            <div className={`absolute inset-0 loading loading-spinner ${sizeClasses[size]} text-primary/20 animate-ping`}></div>
          </div>
          <p className="mt-6 text-lg font-semibold text-base-content">
            Загрузка...
          </p>
          <p className="mt-2 text-sm text-base-content/70">Пожалуйста, подождите</p>
        </div>
      </div>
    );
  }

  return (
    <span className={`loading loading-spinner ${sizeClasses[size]} text-primary animate-pulse`}></span>
  );
};

export default LoadingSpinner;
